//import polyfill from './modules/polyfills';
//import { docReady } from './modules/utilities';
import { eventListeners } from '../templates/components/market-header/market-header';
import { neighborhoodsCarousel } from '../templates/components/market-neighborhoods/market-neighborhoods';
import { toggleCommunitiesQuickActions, toggleFilters, handleQuickViewModal, communityList } from '../templates/components/maa-communities/maa-communities';
import { compareCommunities } from '../templates/components/compare-communities/compare-communities';
import { compareView } from '../templates/components/compare-view/compare-view';
import { availableApartments } from '../templates/components/available-apartments/available-apartments';
import { whyChoose } from '../templates/components/why-choose/why-choose';
import { propertyHeroSlider } from '../templates/components/property-hero-gallery/property-hero-gallery';
import { videoGallery } from '../templates/components/video-gallery/video-gallery';
import { gallery360 } from '../templates/components/360-gallery/360-gallery';
// import { saveCommunity } from "./components/save-community";
import { handleFeaturesModal } from '../templates/components/property-perks/property-perks';
import { verticalCarousel } from '../templates/components/vertical-carousel/vertical-carousel';
import { handleComplexLayoutCarousel } from '../templates/components/complex-layout-carousel/complex-layout-carousel';
import { savedItems } from '../templates/components/saved-items/saved-items';
import { footer } from '../templates/components/footer/footer';
import { propertyDetails } from '../templates/components/property-details-component/property-details-component';
import { propertyFeatures } from '../templates/components/property-features/property-features';
import { initPhotoGallery } from '../templates/components/photo-gallery/photo-gallery';
import { communitiesNearYou } from '../templates/components/communities-near-you/communities-near-you';
import { communitiesFilter } from '../templates/components/communities-filter/communities-filter';
import { initDynamicButtons } from './components/dynamic-buttons';
import { setStickySectionsTop } from "./components/sticky-sections";
import { leasingTerms } from '../templates/components/leasing-terms/leasing-terms';
import { leaseUpForm } from '../templates/components/lease-up-form/lease-up-form';
import { video360TourLanding } from '../templates/components/360-video-tour-landing/360-video-tour-landing';
import { initHeroPlay } from '../templates/components/sustainability-hero/sustainability-hero';
import { sustainabilityChart } from '../templates/components/sustainability-chart/sustainability-chart';
import { sustainabilityPillar } from '../templates/components/sustainability-pillar/sustainability-pillar';
import { sustainabilityReports } from '../templates/components/sustainability-reports/sustainability-reports';
import { initHeroCarousel } from '../templates/components/newdev-hero/newdev-hero';
import { newdevNews } from '../templates/components/newdev-news/newdev-news';
import { initStats } from '../templates/components/our-locations/our-locations';
import { initLeadership } from '../templates/components/newdev-leadership/leadership';

const components = [
  setStickySectionsTop,
  eventListeners,
  neighborhoodsCarousel,
  toggleCommunitiesQuickActions,
  toggleFilters,
  compareCommunities,
  compareView,
  availableApartments,
  whyChoose,
  propertyHeroSlider,
  videoGallery,
  gallery360,
  handleFeaturesModal,
  verticalCarousel,
  handleComplexLayoutCarousel,
  savedItems,
  handleQuickViewModal,
  footer,
  propertyDetails,
  propertyFeatures,
  communityList,
  initPhotoGallery,
  communitiesNearYou,
  neighborhoodsCarousel,
  communitiesFilter,
  initDynamicButtons,
  leasingTerms,
  leaseUpForm,
  video360TourLanding,
  initHeroPlay,
  sustainabilityChart,
  sustainabilityPillar,
  sustainabilityReports,
  initHeroCarousel,
  newdevNews,
  initStats,
  initLeadership
];

// eslint-disable-next-line func-names, prefer-arrow-callback, no-undef
document.addEventListener("DOMContentLoaded", function() {
  for (let component of components) {
    try {
      component();
    } catch (e) {
      console.error(e);
    }
  }
});



// WEBPACK FOOTER //
// ./src/js/app.js